import React from "react";
import FiltersHeader from "./FiltersHeader";
import AllFilters from "./AllFilters";
import { useSearchParams } from "react-router-dom";

const FiltersWrapper = ({
  headLine,
  renderAllFilters = false,
  filters,
  handleFiltersChange,
  handleToggleRenderAllFilters,
  handleResetFilters,
  isDayView = false,
}) => {
  const [searchParams] = useSearchParams();
  const openAllFilters =
    searchParams.get("allFilters") !== null || renderAllFilters;

  const type = isDayView ? "calendar" : "ranges";

  return openAllFilters ? (
    <AllFilters
      {...{
        filters,
        handleFiltersChange,
        headLine,
        handleToggleRenderAllFilters,
        handleResetFilters,
        type,
      }}
    />
  ) : (
    <FiltersHeader
      {...{
        filters,
        handleFiltersChange,
        handleToggleRenderAllFilters,
        handleResetFilters,
        type,
      }}
    />
  );
};

export default FiltersWrapper;
